import { AuthRequired } from "@redotech/redo-merchant-app-common/auth";
import { RouteObject } from "react-router-dom";

export const oauthRoutes: RouteObject[] = [
  {
    path: "authorize/:clientId",
    async lazy() {
      const { Authorize } = await import("./authorize");
      return {
        element: (
          <AuthRequired>
            <Authorize />
          </AuthRequired>
        ),
      };
    },
  },
];
